import React from "react";
import PropTypes from "prop-types";
import { cn } from "../../utils/classNames";

const sizeClasses = {
  sm: "h-11 w-11",
  md: "h-10 w-10",
  lg: "h-11 w-11",
};

const IconBadge = ({ children, size = "md", className }) => {
  return (
    <div
      className={cn(
        "flex items-center justify-center border border-primary bg-background shadow-button-3d rounded-md",
        sizeClasses[size],
        className
      )}
    >
      {children}
    </div>
  );
};

IconBadge.propTypes = {
  children: PropTypes.node.isRequired,
  size: PropTypes.oneOf(["sm", "md", "lg"]),
  className: PropTypes.string,
};

export default IconBadge;
